module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_2"
    }
  }, [_c('span', [_vm._v("Elf Shot")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoInd"
  }, [_vm._v("By TA Moore")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("All Conri wanted was to drop his kid off at Changeling camp, find the nearest halfway nice hotel, and enjoy a week of uncomplicated debauchery. It should be simple. It doesn’t work out that way.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When a local girl disappears, the neighborhood quickly lays blame at the well-guarded gates of the camp. With his son incriminated, a mystery to solve, and a malevolent pocket of the Otherworld to navigate, Conri will need all the help he can get—even if it does come from a distractingly pretty, tightly wound Iron Door agent who doesn’t trust Conri to be on the right side.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6328bbc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0